// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #009ef7;
  --primary-light: #66c0ff;
  --body: #455560;
  --body-bg: #fff;
  --color-hover: #699dff;
  --color-active: #2a59d1;
  --color-disabled: #d0d4d7;
  --captions: #72849a;
  --mark: #feffe6;
  --selection-color: #fff;
  --alert-success-bg: #e6fff1;
  --alert-success-border: #7cf7bc;
  --success-icon-color: #04d182;
  --alert-info-bg: #f0f7ff;
  --alert-info-border: #bad7ff;
  --alert-warning-bg: #fff1f0;
  --alert-warning-color: #ffe7e6;
  --warning-icon-color: #ffc542;
  --alert-error-bg: #fff1f0;
  --alert-error-border: #ffe7e6;
  --error-icon-color: #ff6b72;
  --close-icon: #455560;
  --alert-description-color: #1a3353;
  --alert-colors: #ffffff;
  --anchor-wrapper-bg: #fff;
  --anchor-before-bg: #e6ebf1;
  --anchor-before-bg2: #e6ebf1;
  --avatar: #fff;
  --avatar-bg: #ededed;
  --badge-status: #fafafb;
  --badge-pink: #eb2f96;
  --badge-red: #de4436;
  --badge-volcano: #ff6b72;
  --badge-orange: #fa8c16;
  --badge-yellow: #fadb14;
  --badge-gold: #ffc542;
  --badge-cyan: #04d182;
  --badge-line: #a0d911;
  --badge-green: #21b573;
  --badge-blue: #3e79f7;
  --badge-geekblue: #17bcff;
  --badge-purple: #a461d8;
  --ribbon-after: rgba(0, 0, 0, 0.25);
  --breadcrumb-hover: #699dff;
  --btn: rgba(0, 0, 0, 0.015);
  --btn-active: #2a59d1;
  --btn-disabled: #f7f7f8;
  --btn-text-shadow: rgba(0, 0, 0, 0.12);
  --btn-box-shadow: rgba(0, 0, 0, 0.045);
  --btn-danger: #ff9496;
  --btn-danger-active: #d9505c;
  --btn-text-hover: rgba(0, 0, 0, 0.018);
  --btn-text-active: rgba(0, 0, 0, 0.028);
  --btn-text-none: 0 0;
  --btn-dangerous: #ff9496;
  --calendar-date: #f5f5f5;
  --calendar-date-today: #f0f7ff;
  --card-hoverable: rgba(0, 0, 0, 0.16);
  --card-head: #fafafa;
  --card-loading-bg: linear-gradient(
    90deg,
    rgba(207, 216, 220, 0.2),
    rgba(207, 216, 220, 0.4),
    rgba(207, 216, 220, 0.2)
  );
  --author-time: rgba(26, 51, 83, 0.6);
  --comment-actions: #595959;
  --picker-focused: rgba(62, 121, 247, 0.2);
  --picker-range: #bad7ff;
  --picker-range-shadow: rgba(0, 0, 0, 0.06);
  --picker-panel: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  --picker-cell: rgba(62, 121, 247, 0.1);
  --picker-cell-range: #a0bdfb;
  --picker-date-panel: #e9f0fe;
  --picker-time: rgba(38, 51, 82, 0.2);
  --description-border: #f7f7f8;
  --drawer-right: -6px 0 16px -8px rgba(0, 0, 0, 0.08),
    -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03);
  --drawer-mask: rgba(0, 0, 0, 0.45);
  --picker-clear: #fff;
  --drawer: #fff;
  --drower-arrow: rgba(0, 0, 0, 0.07);
  --drower-menu: #99abb4;
  --empty-default: #dce0e6;
  --empty-default-1: #aeb8c2;
  --upload-drag: #fafafa;
  --picker-input: rgba(114, 132, 154, 0.4);
  --calendar-picker: rgba(255, 107, 114, 0.2);
  --img-placeholder: #f5f5f5;
  --img-mask: rgba(0, 0, 0, 0.5);
  --input-affix: #455560;
  --input-group-addon: #f7f7f8;
  --menu-item-active: #fff4f0;
  --input-border: #e6ebf1;
  --input-color: #455560;
  --dropdown-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  --tab-tab: #ffffff;
  --table-header-hover: #f5f5f5;
  --table-tr-hover: #f5f5f5;
  --table-column: #f0f7ff;
  --table-column-sorter: #f7f7f7;
  --notification-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  --modal-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  --row-selected-hover: #e6f2ff;
  --btn-default: #ededed;
  --skeleton-shadow: linear-gradient(
    90deg,
    rgba(190, 190, 190, 0.2) 25%,
    rgba(129, 129, 129, 0.24) 37%,
    rgba(190, 190, 190, 0.2) 63%
  );
  --chair_bg: #e1e1e1;
  --green: #27b580;
  --red: #f0416c;
  --box-shadow: #009ef7;
  --btn-primary-hover: #009cf7dd;
  --btn-primary-active: #01a2ff;
  --menu: #3e79f7;
  --menubg: #e6f7ff;
  --dark: rgb(47, 47, 47);
  --dropdawnbg: #fafafa;
  --background: #fafafb;
  --tab-next: #0d6efd;
  --subscribe: #18a695;
  --subscribe-text: #233342;
  --white: #ffffff;
  --black: rgba(0, 0, 0, 1);
  --danger: #ff0004;
  --chat-date: rgba(164, 164, 164, 0.46);
  --chat-bg: #f3f3f0;
  --curier-sms-bg: #f0f2f5;
  --user-sms-bg: #fff;
  --primary-text: #000;
  --ingrediend-text: rgb(0, 0, 0);
  --ingrediend-border: rgba(0, 0, 0, 0.05);
  --sidebar-active: rgba(62, 121, 247, 0.1);
  --border-color: #e6ebf1;
  --border-color-bg: #fff;
  --border-color-bg-dark: #48566f;
  --grey: #ededed;
  --dark-background: #283142;
  --dark-grey: #4d5b75;
  --light-text: #d6d7dc;
  --dark-blue: #1b2531;
  --dark-red: #ff6b72;
  --dark-muted-text: rgba(114, 132, 154, 0.9);
  --dark-primary-hover: rgba(62, 121, 247, 0.1);
  --bg-color: #323d52;
  --global-bg: rgba(255, 255, 255, 0.28);
  --border: #f1f1f4;
  --skeleton-bg: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
  --text: rgba(45, 55, 72, 1);
  --divider: #e2e8f0;
  --placeholder: #718096;
}

[data-theme=dark] {
  --body: #b4bed2;
  --body-bg: #1b2531;
  --color-hover: #699dff;
  --color-active: #2a59d1;
  --color-disabled: #9ea8bb;
  --captions: #72849a;
  --mark: #3c3f38;
  --selection-color: #fff;
  --alert-success-bg: rgba(4, 209, 130, 0.1);
  --alert-success-border: rgba(4, 209, 130, 0.1);
  --success-icon-color: #04d182;
  --alert-info-bg: rgba(62, 121, 247, 0.1);
  --alert-info-border: rgba(62, 121, 247, 0.1);
  --alert-warning-bg: rgba(255, 197, 66, 0.1);
  --alert-warning-color: rgba(255, 197, 66, 0.1);
  --warning-icon-color: #ffc542;
  --alert-error-bg: rgba(255, 107, 114, 0.1);
  --alert-error-border: rgba(255, 107, 114, 0.1);
  --error-icon-color: #ff6b72;
  --close-icon: #455560;
  --alert-description-color: #d6d7dc;
  --alert-colors: #ffffff;
  --anchor-wrapper-bg: #283142;
  --anchor-before-bg: #4d5b75;
  --anchor-before-bg2: transparent;
  --avatar: #fff;
  --avatar-bg: #3f4d68;
  --badge-status: #fafafb;
  --badge-pink: #ce2f89;
  --badge-red: #c34138;
  --badge-volcano: #df626b;
  --badge-orange: #db7e1d;
  --badge-yellow: #dbc21b;
  --badge-gold: #dfaf42;
  --badge-cyan: #09b978;
  --badge-line: #8ec018;
  --badge-green: #22a16c;
  --badge-blue: #3b6edc;
  --badge-geekblue: #1aa7e3;
  --badge-purple: #915ac2;
  --ribbon-after: rgba(0, 0, 0, 0.25);
  --breadcrumb-hover: #3660b8;
  --btn: rgba(0, 0, 0, 0.015);
  --btn-active: #6392ec;
  --btn-disabled: #586379;
  --btn-text-shadow: rgba(0, 0, 0, 0.12);
  --btn-box-shadow: rgba(0, 0, 0, 0.045);
  --btn-danger: #d9505c;
  --btn-danger-active: #ff9496;
  --btn-text-hover: rgba(0, 0, 0, 0.018);
  --btn-text-active: rgba(0, 0, 0, 0.028);
  --btn-text-none: rgba(0, 0, 0, 0.028);
  --btn-dangerous: #ff9496;
  --calendar-date: #364663;
  --calendar-date-today: #263352;
  --card-hoverable: rgba(0, 0, 0, 0.16);
  --card-head: rgb(50, 61, 82);
  --card-loading-bg: linear-gradient(
    90deg,
    rgba(59, 73, 98, 0.2),
    rgba(59, 73, 98, 0.4),
    rgba(59, 73, 98, 0.2)
  );
  --author-time: rgba(255, 255, 255, 0.6);
  --comment-actions: #595959;
  --picker-focused: rgba(62, 121, 247, 0.2);
  --picker-range: #2f4778;
  --picker-range-shadow: rgba(0, 0, 0, 0.06);
  --picker-panel: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.58), 0 9px 28px 8px rgba(0, 0, 0, 0.15);
  --picker-cell: rgba(62, 121, 247, 0.1);
  --picker-cell-range: #a0bdfb;
  --picker-date-panel: rgba(135, 172, 250, 0.1);
  --picker-time: rgba(38, 51, 82, 0.2);
  --description-border: #323d52;
  --drawer-right: -6px 0 16px -8px rgba(0, 0, 0, 0.08),
    -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03);
  --drawer-mask: rgba(0, 0, 0, 0.45);
  --picker-clear: #455472;
  --drawer: #272727;
  --drower-arrow: rgba(0, 0, 0, 0.07);
  --drower-menu: #99abb4;
  --empty-default: #434343;
  --empty-default-1: #262626;
  --upload-drag: #fafafa;
  --picker-input: #617190;
  --calendar-picker: rgba(255, 107, 114, 0.2);
  --img-placeholder: #f5f5f5;
  --img-mask: rgba(0, 0, 0, 0.5);
  --input-affix: #617190;
  --input-group-addon: #3b4962;
  --menu-item-active: #382d3b;
  --input-border: #4d5b75;
  --input-color: #b4bed2;
  --dropdown-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.58), 0 9px 28px 8px rgba(0, 0, 0, 0.15);
  --tab-tab: #1b2531;
  --table-header-hover: #424242;
  --table-tr-hover: #222;
  --table-column: #32415c;
  --table-column-sorter: #2f3d56;
  --notification-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.58), 0 9px 28px 8px rgba(0, 0, 0, 0.15);
  --modal-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.58), 0 9px 28px 8px rgba(0, 0, 0, 0.15);
  --row-selected-hover: #232f4b;
  --btn-default: #5c667b;
  --skeleton-shadow: linear-gradient(
    90deg,
    var(--input-group-addon) 25%,
    #38455d 37%,
    var(--input-group-addon) 63%
  );
  --chair_bg: #3b4962;
  --dark-blue: #ffffff;
  --green: #28a745;
  --box-shadow: #009ef7;
  --btn-primary-hover: #009cf7dd;
  --btn-primary-active: #01a2ff;
  --black: #fff;
  --border: #4d5b75;
  --skeleton-bg: linear-gradient(110deg, #38455d 8%, #4d5b75 18%, #38455d 33%);
  --text: rgb(180, 190, 210);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/variables.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,+BAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,kCAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qBAAA;EACA,uBAAA;EACA,sCAAA;EACA,sCAAA;EACA,qBAAA;EACA,4BAAA;EACA,sCAAA;EACA,uCAAA;EACA,oBAAA;EACA,wBAAA;EACA,wBAAA;EACA,8BAAA;EACA,qCAAA;EACA,oBAAA;EACA;;;;;GAAA;EAMA,oCAAA;EACA,0BAAA;EACA,yCAAA;EACA,uBAAA;EACA,0CAAA;EACA;wEAAA;EAEA,sCAAA;EACA,4BAAA;EACA,4BAAA;EACA,oCAAA;EACA,6BAAA;EACA;4EAAA;EAEA,kCAAA;EACA,oBAAA;EACA,cAAA;EACA,mCAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,sBAAA;EACA,wCAAA;EACA,2CAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA;wEAAA;EAEA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,8BAAA;EACA;wEAAA;EAEA;wEAAA;EAEA,6BAAA;EACA,sBAAA;EACA;;;;;GAAA;EAMA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sCAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,oBAAA;EACA,+BAAA;EACA,wCAAA;EACA,yCAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;EACA,0BAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,2CAAA;EACA,6CAAA;EACA,mBAAA;EACA,sCAAA;EACA,iBAAA;EACA,4EAAA;EACA,2BAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,0CAAA;EACA,8CAAA;EACA,6BAAA;EACA,wCAAA;EACA,4CAAA;EACA,2CAAA;EACA,8CAAA;EACA,6BAAA;EACA,0CAAA;EACA,8CAAA;EACA,2BAAA;EACA,qBAAA;EACA,kCAAA;EACA,uBAAA;EACA,4BAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qBAAA;EACA,uBAAA;EACA,sCAAA;EACA,sCAAA;EACA,qBAAA;EACA,4BAAA;EACA,sCAAA;EACA,uCAAA;EACA,qCAAA;EACA,wBAAA;EACA,wBAAA;EACA,8BAAA;EACA,qCAAA;EACA,4BAAA;EACA;;;;;GAAA;EAMA,uCAAA;EACA,0BAAA;EACA,yCAAA;EACA,uBAAA;EACA,0CAAA;EACA;wEAAA;EAEA,sCAAA;EACA,4BAAA;EACA,6CAAA;EACA,oCAAA;EACA,6BAAA;EACA;4EAAA;EAEA,kCAAA;EACA,uBAAA;EACA,iBAAA;EACA,mCAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2CAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA;wEAAA;EAEA,kBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA;wEAAA;EAEA;wEAAA;EAEA,6BAAA;EACA,sBAAA;EACA;;;;;GAAA;EAMA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,aAAA;EACA,iBAAA;EACA,4EAAA;EACA,0BAAA;AACF","sourcesContent":[":root {\n  --primary: #009ef7;\n  --primary-light: #66c0ff;\n  --body: #455560;\n  --body-bg: #fff;\n  --color-hover: #699dff;\n  --color-active: #2a59d1;\n  --color-disabled: #d0d4d7;\n  --captions: #72849a;\n  --mark: #feffe6;\n  --selection-color: #fff;\n  --alert-success-bg: #e6fff1;\n  --alert-success-border: #7cf7bc;\n  --success-icon-color: #04d182;\n  --alert-info-bg: #f0f7ff;\n  --alert-info-border: #bad7ff;\n  --alert-warning-bg: #fff1f0;\n  --alert-warning-color: #ffe7e6;\n  --warning-icon-color: #ffc542;\n  --alert-error-bg: #fff1f0;\n  --alert-error-border: #ffe7e6;\n  --error-icon-color: #ff6b72;\n  --close-icon: #455560;\n  --alert-description-color: #1a3353;\n  --alert-colors: #ffffff;\n  --anchor-wrapper-bg: #fff;\n  --anchor-before-bg: #e6ebf1;\n  --anchor-before-bg2: #e6ebf1;\n  --avatar: #fff;\n  --avatar-bg: #ededed;\n  --badge-status: #fafafb;\n  --badge-pink: #eb2f96;\n  --badge-red: #de4436;\n  --badge-volcano: #ff6b72;\n  --badge-orange: #fa8c16;\n  --badge-yellow: #fadb14;\n  --badge-gold: #ffc542;\n  --badge-cyan: #04d182;\n  --badge-line: #a0d911;\n  --badge-green: #21b573;\n  --badge-blue: #3e79f7;\n  --badge-geekblue: #17bcff;\n  --badge-purple: #a461d8;\n  --ribbon-after: rgba(0, 0, 0, 0.25);\n  --breadcrumb-hover: #699dff;\n  --btn: rgba(0, 0, 0, 0.015);\n  --btn-active: #2a59d1;\n  --btn-disabled: #f7f7f8;\n  --btn-text-shadow: rgba(0, 0, 0, 0.12);\n  --btn-box-shadow: rgba(0, 0, 0, 0.045);\n  --btn-danger: #ff9496;\n  --btn-danger-active: #d9505c;\n  --btn-text-hover: rgba(0, 0, 0, 0.018);\n  --btn-text-active: rgba(0, 0, 0, 0.028);\n  --btn-text-none: 0 0;\n  --btn-dangerous: #ff9496;\n  --calendar-date: #f5f5f5;\n  --calendar-date-today: #f0f7ff;\n  --card-hoverable: rgba(0, 0, 0, 0.16);\n  --card-head: #fafafa;\n  --card-loading-bg: linear-gradient(\n    90deg,\n    rgba(207, 216, 220, 0.2),\n    rgba(207, 216, 220, 0.4),\n    rgba(207, 216, 220, 0.2)\n  );\n  --author-time: rgba(26, 51, 83, 0.6);\n  --comment-actions: #595959;\n  --picker-focused: rgba(62, 121, 247, 0.2);\n  --picker-range: #bad7ff;\n  --picker-range-shadow: rgba(0, 0, 0, 0.06);\n  --picker-panel: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  --picker-cell: rgba(62, 121, 247, 0.1);\n  --picker-cell-range: #a0bdfb;\n  --picker-date-panel: #e9f0fe;\n  --picker-time: rgba(38, 51, 82, 0.2);\n  --description-border: #f7f7f8;\n  --drawer-right: -6px 0 16px -8px rgba(0, 0, 0, 0.08),\n    -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03);\n  --drawer-mask: rgba(0, 0, 0, 0.45);\n  --picker-clear: #fff;\n  --drawer: #fff;\n  --drower-arrow: rgba(0, 0, 0, 0.07);\n  --drower-menu: #99abb4;\n  --empty-default: #dce0e6;\n  --empty-default-1: #aeb8c2;\n  --upload-drag: #fafafa;\n  --picker-input: rgba(114, 132, 154, 0.4);\n  --calendar-picker: rgba(255, 107, 114, 0.2);\n  --img-placeholder: #f5f5f5;\n  --img-mask: rgba(0, 0, 0, 0.5);\n  --input-affix: #455560;\n  --input-group-addon: #f7f7f8;\n  --menu-item-active: #fff4f0;\n  --input-border: #e6ebf1;\n  --input-color: #455560;\n  --dropdown-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  --tab-tab: #ffffff;\n  --table-header-hover: #f5f5f5;\n  --table-tr-hover: #f5f5f5;\n  --table-column: #f0f7ff;\n  --table-column-sorter: #f7f7f7;\n  --notification-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  --modal-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  --row-selected-hover: #e6f2ff;\n  --btn-default: #ededed;\n  --skeleton-shadow: linear-gradient(\n    90deg,\n    rgba(190, 190, 190, 0.2) 25%,\n    rgba(129, 129, 129, 0.24) 37%,\n    rgba(190, 190, 190, 0.2) 63%\n  );\n  --chair_bg: #e1e1e1;\n  --green: #27b580;\n  --red: #f0416c;\n  --box-shadow: #009ef7;\n  --btn-primary-hover: #009cf7dd;\n  --btn-primary-active: #01a2ff;\n  --menu: #3e79f7;\n  --menubg: #e6f7ff;\n  --dark: rgb(47, 47, 47);\n  --dropdawnbg: #fafafa;\n  --background: #fafafb;\n  --tab-next: #0d6efd;\n  --subscribe: #18a695;\n  --subscribe-text: #233342;\n  --white: #ffffff;\n  --black: rgba(0, 0, 0, 1);\n  --danger: #ff0004;\n  --chat-date: rgba(164, 164, 164, 0.46);\n  --chat-bg: #f3f3f0;\n  --curier-sms-bg: #f0f2f5;\n  --user-sms-bg: #fff;\n  --primary-text: #000;\n  --ingrediend-text: rgb(0, 0, 0);\n  --ingrediend-border: rgba(0, 0, 0, 0.05);\n  --sidebar-active: rgba(62, 121, 247, 0.1);\n  --border-color: #e6ebf1;\n  --border-color-bg: #fff;\n  --border-color-bg-dark: #48566f;\n  --grey: #ededed;\n  --dark-background: #283142;\n  --dark-grey: #4d5b75;\n  --light-text: #d6d7dc;\n  --dark-blue: #1b2531;\n  --dark-red: #ff6b72;\n  --dark-muted-text: rgba(114, 132, 154, 0.9);\n  --dark-primary-hover: rgba(62, 121, 247, 0.1);\n  --bg-color: #323d52;\n  --global-bg: rgba(255, 255, 255, 0.28);\n  --border: #f1f1f4;\n  --skeleton-bg: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n  --text: rgba(45, 55, 72, 1);\n  --divider: #e2e8f0;\n  --placeholder: #718096;\n}\n\n[data-theme='dark'] {\n  --body: #b4bed2;\n  --body-bg: #1b2531;\n  --color-hover: #699dff;\n  --color-active: #2a59d1;\n  --color-disabled: #9ea8bb;\n  --captions: #72849a;\n  --mark: #3c3f38;\n  --selection-color: #fff;\n  --alert-success-bg: rgba(4, 209, 130, 0.1);\n  --alert-success-border: rgba(4, 209, 130, 0.1);\n  --success-icon-color: #04d182;\n  --alert-info-bg: rgba(62, 121, 247, 0.1);\n  --alert-info-border: rgba(62, 121, 247, 0.1);\n  --alert-warning-bg: rgba(255, 197, 66, 0.1);\n  --alert-warning-color: rgba(255, 197, 66, 0.1);\n  --warning-icon-color: #ffc542;\n  --alert-error-bg: rgba(255, 107, 114, 0.1);\n  --alert-error-border: rgba(255, 107, 114, 0.1);\n  --error-icon-color: #ff6b72;\n  --close-icon: #455560;\n  --alert-description-color: #d6d7dc;\n  --alert-colors: #ffffff;\n  --anchor-wrapper-bg: #283142;\n  --anchor-before-bg: #4d5b75;\n  --anchor-before-bg2: transparent;\n  --avatar: #fff;\n  --avatar-bg: #3f4d68;\n  --badge-status: #fafafb;\n  --badge-pink: #ce2f89;\n  --badge-red: #c34138;\n  --badge-volcano: #df626b;\n  --badge-orange: #db7e1d;\n  --badge-yellow: #dbc21b;\n  --badge-gold: #dfaf42;\n  --badge-cyan: #09b978;\n  --badge-line: #8ec018;\n  --badge-green: #22a16c;\n  --badge-blue: #3b6edc;\n  --badge-geekblue: #1aa7e3;\n  --badge-purple: #915ac2;\n  --ribbon-after: rgba(0, 0, 0, 0.25);\n  --breadcrumb-hover: #3660b8;\n  --btn: rgba(0, 0, 0, 0.015);\n  --btn-active: #6392ec;\n  --btn-disabled: #586379;\n  --btn-text-shadow: rgba(0, 0, 0, 0.12);\n  --btn-box-shadow: rgba(0, 0, 0, 0.045);\n  --btn-danger: #d9505c;\n  --btn-danger-active: #ff9496;\n  --btn-text-hover: rgba(0, 0, 0, 0.018);\n  --btn-text-active: rgba(0, 0, 0, 0.028);\n  --btn-text-none: rgba(0, 0, 0, 0.028);\n  --btn-dangerous: #ff9496;\n  --calendar-date: #364663;\n  --calendar-date-today: #263352;\n  --card-hoverable: rgba(0, 0, 0, 0.16);\n  --card-head: rgb(50, 61, 82);\n  --card-loading-bg: linear-gradient(\n    90deg,\n    rgba(59, 73, 98, 0.2),\n    rgba(59, 73, 98, 0.4),\n    rgba(59, 73, 98, 0.2)\n  );\n  --author-time: rgba(255, 255, 255, 0.6);\n  --comment-actions: #595959;\n  --picker-focused: rgba(62, 121, 247, 0.2);\n  --picker-range: #2f4778;\n  --picker-range-shadow: rgba(0, 0, 0, 0.06);\n  --picker-panel: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.58), 0 9px 28px 8px rgba(0, 0, 0, 0.15);\n  --picker-cell: rgba(62, 121, 247, 0.1);\n  --picker-cell-range: #a0bdfb;\n  --picker-date-panel: rgba(135, 172, 250, 0.1);\n  --picker-time: rgba(38, 51, 82, 0.2);\n  --description-border: #323d52;\n  --drawer-right: -6px 0 16px -8px rgba(0, 0, 0, 0.08),\n    -9px 0 28px 0 rgba(0, 0, 0, 0.05), -12px 0 48px 16px rgba(0, 0, 0, 0.03);\n  --drawer-mask: rgba(0, 0, 0, 0.45);\n  --picker-clear: #455472;\n  --drawer: #272727;\n  --drower-arrow: rgba(0, 0, 0, 0.07);\n  --drower-menu: #99abb4;\n  --empty-default: #434343;\n  --empty-default-1: #262626;\n  --upload-drag: #fafafa;\n  --picker-input: #617190;\n  --calendar-picker: rgba(255, 107, 114, 0.2);\n  --img-placeholder: #f5f5f5;\n  --img-mask: rgba(0, 0, 0, 0.5);\n  --input-affix: #617190;\n  --input-group-addon: #3b4962;\n  --menu-item-active: #382d3b;\n  --input-border: #4d5b75;\n  --input-color: #b4bed2;\n  --dropdown-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.58), 0 9px 28px 8px rgba(0, 0, 0, 0.15);\n  --tab-tab: #1b2531;\n  --table-header-hover: #424242;\n  --table-tr-hover: #222;\n  --table-column: #32415c;\n  --table-column-sorter: #2f3d56;\n  --notification-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.58), 0 9px 28px 8px rgba(0, 0, 0, 0.15);\n  --modal-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.58), 0 9px 28px 8px rgba(0, 0, 0, 0.15);\n  --row-selected-hover: #232f4b;\n  --btn-default: #5c667b;\n  --skeleton-shadow: linear-gradient(\n    90deg,\n    var(--input-group-addon) 25%,\n    #38455d 37%,\n    var(--input-group-addon) 63%\n  );\n  --chair_bg: #3b4962;\n  --dark-blue: #ffffff;\n  --green: #28a745;\n  --box-shadow: #009ef7;\n  --btn-primary-hover: #009cf7dd;\n  --btn-primary-active: #01a2ff;\n  --black: #fff;\n  --border: #4d5b75;\n  --skeleton-bg: linear-gradient(110deg, #38455d 8%, #4d5b75 18%, #38455d 33%);\n  --text: rgb(180, 190, 210);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
